import React, { useReducer, useMemo } from 'react'

import PropTypes from 'prop-types'

import { ToastContext, toastReducer } from './Toast.context'
import { ToastList } from './ToastList.presentation'

export const ToastProvider = ({ children }) => {
  const initialState = []

  const [state, dispatch] = useReducer(toastReducer, initialState)
  const toastContextValue = useMemo(() => ({ state, dispatch }), [state, dispatch])

  return (
    <ToastContext.Provider value={toastContextValue}>
      {children}
      <ToastList />
    </ToastContext.Provider>
  )
}

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
